export default function (){
    $("#sl-js-page-index").on('change', function () {
        $("#sl-js-page-select-form").trigger('submit');
    });
}
